var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFsDndSmallDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .fs-disabled{fill:#c8c8c8;fill-rule:evenodd}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_sync_protocol_40_disabled",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_70",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M35.4 19v5.1H15V19zm-1.275 1.912h-1.276v1.275h1.275zm-2.55 0H30.3v1.275h1.275zm-2.55 0h-1.276v1.275h1.275z",
    className: "fs-disabled",
    transform: "translate(-5 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy",
    d: "M35.4 27v5.1H15V27zm-1.275 1.912h-1.276v1.275h1.275zm-2.55 0H30.3v1.275h1.275zm-2.55 0h-1.276v1.275h1.275z",
    className: "fs-disabled",
    transform: "translate(-5 -6.769)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsDndSmallDisabled);
export default __webpack_public_path__ + "static/media/fs-dnd-small-disabled.e2f7207a5a0f7c78d842a2447b5a7988.svg";
export { ForwardRef as ReactComponent };